
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from "react";
import Head from "next/head";
import Link from "next/link";
import MainLayout from "../../components/layout/MainLayout";
import Navigation from "../../components/layout/Navigation";
import Footer from "../../components/layout/Footer";
import ArticleContent from "../../components/Blog/ArticleContent";
import ArticleMeta from "../../components/Blog/ArticleMeta";
import ArticleNavigation from "../../components/Blog/ArticleNavigation";
import { fetchArticleBySlug, fetchAdjacentArticles } from "../../lib/strapi";
import styles from "../../styles/blog/blogDetail.module.scss";
export default function BlogArticle({ article, adjacentArticles }) {
    if (!article)
        return null;
    const siteUrl = process.env.NEXT_PUBLIC_SITE_URL;
    const coverUrl = article.cover?.url || `${siteUrl}/og.png`;
    const articleSchema = {
        "@context": "https://schema.org",
        "@type": "Article",
        "headline": article.title,
        "description": article.description,
        "image": coverUrl,
        "datePublished": article.publishedAt,
        "author": {
            "@type": "Person",
            "name": article.author?.name || "HFDX"
        },
        "publisher": {
            "@type": "Organization",
            "name": "HFDX",
            "logo": {
                "@type": "ImageObject",
                "url": `${siteUrl}/logo.png`
            }
        },
        "mainEntityOfPage": {
            "@type": "WebPage",
            "@id": `${siteUrl}/blog/${article.slug}`
        }
    };
    return (<MainLayout title={`${article.title} | HFDX Blog`} description={article.description} page="blog_detail_page" alternate={`blog/${article.slug}`} canonical={`/blog/${article.slug}`} loaded={true} schemaData={articleSchema}>
            <Head>
                <meta property="og:image" content={coverUrl}/>
                <meta property="og:type" content="article"/>
                <meta name="twitter:image" content={coverUrl}/>
                <meta property="article:published_time" content={article.publishedAt}/>
            </Head>
            <Navigation />
            <article className={styles.articlePage}>
                <div className={styles.hero}>
                    <img src={coverUrl} alt={article.cover?.alternativeText || article.title} className={styles.heroImage}/>
                    <div className={styles.heroOverlay}></div>
                    <div className={styles.heroContent}>
                        <div className="container">
                            <h1 className={styles.heroTitle}>{article.title}</h1>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className={styles.articleBody}>
                        <ArticleMeta author={article.author} publishedAt={article.publishedAt} readTime={article.readTime} category={article.category}/>
                        <ArticleContent content={article.content}/>
                        <ArticleNavigation prev={adjacentArticles?.prev} next={adjacentArticles?.next}/>
                        <div className={styles.backLink}>
                            <Link href="/blog">
                                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12.6667 8H3.33337" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                    <path d="M8 3.33337L3.33337 8.00004L8 12.6667" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                                Back to Blog
                            </Link>
                        </div>
                    </div>
                </div>
            </article>
            <Footer />
        </MainLayout>);
}
async function getServerSideProps({ params }) {
    try {
        const article = await fetchArticleBySlug(params.slug);
        if (!article) {
            return { notFound: true };
        }
        const adjacentArticles = await fetchAdjacentArticles(article.publishedAt);
        return {
            props: {
                article,
                adjacentArticles
            }
        };
    }
    catch (error) {
        console.error('Blog detail error:', error?.message);
        return { notFound: true };
    }
}

    async function __Next_Translate__getServerSideProps__1a17ab3f2ed__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/blog/[slug]',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a17ab3f2ed__ as getServerSideProps }
  